import type { Components, Theme } from "@mui/material";

export const popoverTheme: Components<Theme>["MuiPopover"] = {
  defaultProps: {
    elevation: 16,
  },
};
